module.exports = __webpack_public_path__ + "img/loader-logo.91ea9f62.png";